import { type CSSProperties, PureComponent } from "react";

import { IconClickable, IconClickableType } from "~/common/components/icon/IconClickable";
import { IconType } from "~/common/components/icon/IconType";
import { type WithTranslation } from "react-i18next";
import { withTranslation as withTranslationBase } from "react-i18next";

interface SalesmanDetailsToggleProps extends WithTranslation {
  className?: string;
  style?: CSSProperties;
  checked?: boolean;
  onCheck?: (newVal: boolean) => void;
  "data-test-id"?: string;
}

class SalesmanDetailsToggle extends PureComponent<SalesmanDetailsToggleProps, {}> {
  toggle = () => {
    if (this.props.onCheck) {
      this.props.onCheck(!this.props.checked);
    }
  };

  render() {
    const { checked, className, ...rest } = this.props;
    const cls = `d-flex flex-align-center ${className ? className : ""}`;

    const iconType = checked ? IconType.Eye : IconType.EyeOff;

    return (
      <IconClickable
        // data-test-id={"active-quote-toggle-details"}
        className={cls}
        onIconClick={this.toggle}
        type={iconType}
        clickableType={IconClickableType.PRIMARY}
        {...rest}
      />
    );
  }
}

export default withTranslationBase()(SalesmanDetailsToggle);
